<template>
    <div class="channel-selector">
        <div class="channel-selector__title">
            <div class="channel-selector__title-name">
                <span>{{ $t('words.recoding_channel') }}</span>
            </div>
            <div class="channel-selector__title-arrow">
                <i :class="{'icon': true, 'icon-arrow-down-sm': true, 'is-rotate':  accordionChannel}"
                   @click="handleArrowClick"></i>
            </div>
        </div>
        <perfect-scrollbar v-if="recordingChannels.length > 0"
                           :class="{'channel-selector__list':true, 'hide': !accordionChannel}">
            <ul>
                <li class="form-checkbox">
                    <input id="channel_all_check" :checked="allChecked"
                           type="checkbox"
                           @input="handleAllCheck">
                    <label for="channel_all_check"></label>
                    <span :class="['channel-label']">
                        {{ $t('words.all_recoding_channel') }}
                    </span>
                </li>
                <li v-for="(recordingChannel, index) in recordingChannels"
                    :key="`recordingChannels_${recordingChannel.title}_${index}`"
                    class="form-checkbox channel-list">
                    <input :id="`recordingChannel_${index+1}_check`" :checked="recordingChannel.checked"
                           type="checkbox"
                           @input="handleChannelCheck(index, !recordingChannel.checked)">
                    <label :class="`check-channel-${index+1}`" :for="`recordingChannel_${index+1}_check`"></label>
                    <span
                        v-tooltip="{content:`${recordingChannel.title} ${recordingChannel.hided_at ?  `(${$t('words.hide_channel')})`: ''}`, html :false}"
                        :class="['channel-label']">
                        {{ recordingChannel.title }}
                        <span v-if="recordingChannel.hided_at"> {{ `(${$t('words.hide_channel')})` }}</span>
                    </span>
                </li>
            </ul>
        </perfect-scrollbar>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    name: 'ChannelSelector',
    data() {
        return {
            accordionChannel: true,
            allChecked: false,
        };
    },
    computed: {
        ...mapGetters('schedule', ['recordingChannels']),
    },
    watch: {
        recordingChannels: {
            immediate: true,
            deep: true,
            handler(value) {
                const countUncheckedChannel = value.filter(el => !el.checked);

                this.allChecked = countUncheckedChannel.length <= 0;
            },
        },
    },

    async created() {
        await this.fetchRecordingChannels();
        await this.fetchSchedules();
    },

    methods: {
        ...mapActions({
            fetchRecordingChannels: 'schedule/fetchRecordingChannels',
            fetchSchedules: 'schedule/fetchSchedules',
        }),
        ...mapMutations({
            setRecodingChannelsAllChecked: 'schedule/setRecodingChannelsAllChecked',
            setRecordingChannelChecked: 'schedule/setRecordingChannelChecked',
        }),
        handleAllCheck() {
            const status = !this.allChecked;
            this.allChecked = status;
            this.setRecodingChannelsAllChecked(status);
            this.fetchSchedules();
        },
        handleArrowClick() {
            this.accordionChannel = !this.accordionChannel;
        },
        handleChannelCheck(index, checked) {
            const payload = {
                index,
                checked,
            };

            this.setRecordingChannelChecked(payload);
            this.fetchSchedules();
        },
    },
};
</script>
